import Vue from 'vue'
import App from './app.vue'
import "./global/main"; // 全局
import Filter from "./global/filter"; // 过滤器
import router from './config/router' // 路由

import ElementUI from 'element-ui'
import VueMeta from 'vue-meta'
import axios from 'axios'

Vue.use(ElementUI);
Vue.use(VueMeta);

// 过滤器
for (const key in Filter) {
    if (Filter.hasOwnProperty(key)) {
        const element = Filter[key];
        Vue.filter(key, element)
    }
}

// axios
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "csrf";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
let vue = new Vue();
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    // 错误处理
    const err = error.response;
    return Promise.reject(err);
});
Vue.config.productionTip = false;

// 注册
new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
